<template>
  <div>
    <div class="hp-banner">
      <transition name="slide-fade" mode="out-in">
        <template v-for="(banner,i) in banners">
          <div class="hp-banner__grid" v-if="i === index" :key="index">
            <AnimatedTransform3d>
              <div class="hp-banner__text">
                <h2>{{ banner.title }}</h2>
                <div class="bonus">Jusqu'à -70% de Bonus Écologique*</div>
                <small>* sous conditions d'éligibilité</small>
                <div>
                  <a class="button" :href="banner.link">VOIR TOUS LES MODÈLES</a>
                </div>
              </div>
            </AnimatedTransform3d>
            <div class="hero-banner" :style="`background-image: url('${maybeWebpUrl(banner.url)}')`"></div>
          </div>
        </template>
      </transition>
    </div>
    <div class="hp-banner__overlay">
      <div class="hp-banner">
        <div ref="overlay" class="hp-banner__overlay-grid">
          <div>1 véhicule vendu<br>toutes les heures</div>
          <div>14 marques<br>108 modèles</div>
          <div>15 jours d'essai<br>satisfait ou remboursé</div>
          <div>Meilleur prix<br>garanti</div>
          <div>Avis objectif<br>sur chaque modèle</div>
          <div>Livraison<br>partout en France</div>
          <div>Label<br>Fiabilité</div>
        </div>
      </div>
      <div class="banner-progress">
        <div class="progressing"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedTransform3d from "@/front/components/pages/home/AnimatedTransform3d";

export default {
  name: 'HPSlider',
  components: {AnimatedTransform3d},
  data() {
    return {
      banners: [
        {
          title: 'Scooters Électriques',
          link: '/shop',
          url: '/wp-content/uploads/2022/11/banniere-scooter-electrique-2023.jpg'
        },
        {
          title: 'Motos Électriques',
          link: '/shop/cat/moto-electrique',
          url: '/wp-content/uploads/2022/11/banniere-moto-electrique-2023.jpg'
        },
        {
          title: 'Scooters 3 roues',
          link: '/shop/cat/scooter-electrique/3-roues/',
          url: '/wp-content/uploads/2022/11/banniere-3roues-electrique-2023.jpg',
        },
        // {
        //   title: 'Scooters de liviason',
        //   link: '/shop/cat/moto-electrique',
        //   url: '',
        // },
        {
          title: 'Motocross Électrique',
          link: '/shop/cat/moto-electrique/motocross/',
          url: '/wp-content/uploads/2022/11/banniere-motocross-electrique-2023.jpg',
        },
        {
          title: 'Maxi scooters',
          link: '/shop/cat/scooter-electrique/maxi-scooter/',
          url: '/wp-content/uploads/2022/11/banniere-maxi-scooter-electrique-2023.jpg',
        },
      ],
      index: 0,
      webpSupport: false,
    }
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async animateOverlayText() {
      const divs = this.$refs.overlay.querySelectorAll('div')
      for (const div of divs) {
        await this.sleep(100)
        div.classList.add('animate__pulse')
        setTimeout(() => div.classList.remove('animate__pulse'), 1000)
      }
    },
    async supportsWebp() {
      if (!self.createImageBitmap) return false;
      const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
      const blob = await fetch(webpData).then(r => r.blob());
      return createImageBitmap(blob).then(() => true, () => false);
    },
    maybeWebpUrl(str) {
      return this.webpSupport ? `${str}.webp` : str
    },
  },
  async beforeMount() {
    this.webpSupport = await this.supportsWebp()
    setInterval(() => this.animateOverlayText(), 8 * 1000)
    await this.sleep(1000)
    setInterval(() => {
      if (this.index === this.banners.length - 1) {
        this.index = 0
      } else {
        this.index = this.index + 1
      }
    }, 8 * 1000)
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 767px) {
  .hp-banner__overlay {
    .hp-banner__overlay-grid {
      div {
        &:nth-child(n+4) {
          display: none;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 893px) {
  .hp-banner__overlay {
    .hp-banner__overlay-grid {
      div {
        &:nth-child(n+4) {
          display: block;
        }

        &:nth-child(n+5) {
          display: none;
        }
      }
    }
  }
}

.hp-banner {
  max-width: 1320px;
  margin: auto;

  .hp-banner__grid {
    display: grid;
    height: 310px;

    .hp-banner__text {
      align-self: center;

      h2 {
        color: var(--green);
        font-size: 4rem;
        line-height: 1;
        text-transform: uppercase;
        margin: 0;
      }

      div.bonus {
        font-size: 2rem;
      }

      .button {
        padding: 1rem 2rem;
      }
    }
  }
}

.hp-banner__overlay {
  background-color: hsl(198deg 100% 17% / 91%);
  background-image: url('/wp-content/themes/genesis-go2roues/svg/bg/shiny.svg');
  background-repeat: no-repeat;
  background-position-x: 100vw;
  background-blend-mode: overlay;
  background-size: 368px;
  color: white;

  .hp-banner__overlay-grid {
    display: grid;
    grid-gap: .5rem;
    text-align: center;
    font-weight: bold;

    div {
      padding: 1rem .5rem;
    }
  }
}

.banner-progress {
  width: 100%;
  background-color: #d3d3d3;

  div {
    width: 0;
    height: 2px;
    background-color: var(--green);

    &.progressing {
      animation: fill 8s linear infinite;
    }
  }
}

@keyframes fill {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.hero-banner {
  min-height: 314px;
  background-size: cover;
  background-repeat: no-repeat;
  clip-path: polygon(13% 0%, 100% 0%, 100% 100%, 0% 100%);
  display: none;
}

@media screen and (min-width: 490px) {
  .hp-banner__overlay {
    .hp-banner__overlay-grid {
      grid-template-columns: repeat(auto-fit, minmax(160px, auto));
    }
  }
}

@media screen and (min-width: 600px) {
  .hp-banner {
    .hp-banner__grid {
      grid-template-columns: 1fr 1fr;
      height: auto;

      .hero-banner {
        display: block;
      }

    }
  }
}

@media screen and (min-width: 894px) {
  .hp-banner {
    .hp-banner__grid {
      grid-template-columns: 1fr 2fr;
      height: auto;
    }

    .hero-banner {
      background-position-y: -70px;
    }

  }

  .hp-banner__overlay {
    animation: shine-through 8s infinite;

    .hp-banner__overlay-grid {
      div {
        &:nth-child(n+5) {
          display: none;
        }
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .hero-banner {
    min-height: 370px;
  }

  .hp-banner__overlay {

    .hp-banner__overlay-grid {
      div {
        &:nth-child(n+5) {
          display: block;
        }

        &:nth-child(n+6) {
          display: none;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) {
  .hp-banner {
    .hp-banner__grid {
      .hp-banner__text {
        h2 {
          font-size: 5.5rem;
        }
      }
    }
  }

  .hero-banner {
    min-height: 500px;
  }
  .hp-banner__overlay {
    position: absolute;
    width: 100%;
    margin-top: -7rem;

    .hp-banner__overlay-grid {
      div {
        &:nth-child(n+6) {
          display: block;
        }
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.animate__pulse {
  animation: pulse .2s;
}

@keyframes pulse {
  0% {
    transform: scale(1) rotateZ(-1.5deg);
  }
  50% {
    transform: scale(1.06) rotateZ(0);
  }
  100% {
    transform: scale(1) rotateZ(-1.5deg);

  }
}

@keyframes shine-through {
  0%, 80% {
    background-position-y: -150px;
    background-position-x: 100vw;
  }
  100% {
    background-position-y: 10px;
    background-position-x: -20vw;
  }
}
</style>
